import React from "react";
import { Link } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiCheckCircle } from "@mdi/js";
import MainLayout from "layouts/Main";
import { routes } from "constants/routes";

export default function OnBoardingSuccess() {
  return (
    <MainLayout>
      <div className="max-w-sm mx-auto mt-10 rounded-lg shadow-lg overflow-hidden">
        <div className="flex flex-col items-center bg-green-600 text-white p-6">
          <Icon path={mdiCheckCircle} size={3} className="text-white" />
          <h2 className="mt-2 text-lg font-bold">SUCCESS</h2>
        </div>
        <div className="p-6 text-center text-white-700">
          <p>
            Thank you for completing the onboarding process, it may take some time for your account
            to be verified.
          </p>
          <button className="mt-4 bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring">
            <Link to={routes.HAULPAY_BROKER_WALLET}>Return to My Wallet</Link>
          </button>
        </div>
      </div>
    </MainLayout>
  );
}
